import { render } from "./RepairRecive.vue?vue&type=template&id=6f6350d6&scoped=true"
import script from "./RepairRecive.vue?vue&type=script&lang=js"
export * from "./RepairRecive.vue?vue&type=script&lang=js"

import "./RepairRecive.vue?vue&type=style&index=0&id=6f6350d6&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6350d6"]])

export default __exports__